export default __webpack_public_path__ + "static/media/police-dep.0c577066.png";